import TranslateIcon from "@mui/icons-material/Translate";
import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { SupportedLanguage } from "../i18n/config";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation("common");

  const currentLng = (i18n.resolvedLanguage?.slice(0, 2) || "fr") as SupportedLanguage;
  const current = currentLng === "en" ? "en" : "fr";

  const handleSwitch = (lng: SupportedLanguage) => {
    if (lng === current) return;
    void i18n.changeLanguage(lng);
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.6}
      sx={(theme) => ({
        px: 0.7,
        py: 0.25,
        borderRadius: 999,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor:
          theme.palette.mode === "dark" ? "rgba(255,255,255,0.03)" : "rgba(255,255,255,0.75)",
      })}
    >
      <Button
        onClick={() => handleSwitch("fr")}
        startIcon={<TranslateIcon fontSize="small" />}
        color="inherit"
        size="small"
        aria-label={t("toggle.language")}
        sx={{
          minWidth: "auto",
          px: 1.1,
          borderRadius: 999,
          textTransform: "uppercase",
          fontWeight: current === "fr" ? 700 : 500,
          letterSpacing: 0.8,
          backgroundColor: current === "fr" ? "primary.main" : "transparent",
          color: current === "fr" ? "primary.contrastText" : "inherit",
          ".MuiButton-startIcon": { mr: 0.4 },
          "&:hover": { backgroundColor: current === "fr" ? "primary.main" : "action.hover" },
        }}
      >
        FR
      </Button>
      <Typography variant="caption" color="text.secondary">
        |
      </Typography>
      <Button
        onClick={() => handleSwitch("en")}
        color="inherit"
        size="small"
        aria-label={t("toggle.language")}
        sx={{
          minWidth: "auto",
          px: 1.2,
          borderRadius: 999,
          textTransform: "uppercase",
          fontWeight: current === "en" ? 700 : 500,
          letterSpacing: 0.8,
          backgroundColor: current === "en" ? "primary.main" : "transparent",
          color: current === "en" ? "primary.contrastText" : "inherit",
          "&:hover": { backgroundColor: current === "en" ? "primary.main" : "action.hover" },
        }}
      >
        EN
      </Button>
    </Stack>
  );
}
